<template>
  <div class="shop-block orders">
    <preloader :visible="preloader" />
    <v-server-table id="orders-table" ref="orders-table" :url="route" :columns="columns" :options="options"
                    @loading="onLoading" @loaded="onLoaded">

      <template v-slot:order="ctx">{{ ctx.row.id }}</template>
      <template v-slot:date="ctx"><div class="nobr">{{ ctx.row.created_at || '' }}</div></template>
      <template v-slot:user="ctx">{{ ctx.row.user.name }}</template>
      <template v-slot:status="ctx">{{ ctx.row.state }}</template>
      <template v-slot:total="ctx"><div class="font-weight-bold">{{ getOrderTotal(ctx.row).toFixed(2) }}</div></template>
      <template v-slot:child_row="ctx">
        <v-client-table :id="`order-${ctx.row.id}`" :data="ctx.row.items" class="margin-5 table"
                        :columns="itemsTable.columns" :options="itemsTable.options">
          <template v-slot:name="ctx">{{ ctx.row.name }}</template>
          <template v-slot:price="ctx">{{ ctx.row.price }}</template>
          <template v-slot:qty="ctx">{{ ctx.row.qty }}</template>
          <template v-slot:total="ctx">0.00</template>
          <template v-slot:actions="ctx">&nbsp;</template>
          <template v-slot:appendBody>
            <tr><td colspan="5">
              <div class="pull-right">
                <a v-if="ctx.row.state !== 'done'"  class="mr-2 mb-2 btn btn-sm btn-success" v-on:click="shipIt(ctx.row)">Ship It</a>
              </div>
            </td> </tr>
          </template>
        </v-client-table>
        <div>{{ ctx.row.notes }}</div>
      </template>

    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";

export default {
  components: { Preloader },
  props: {
    route: {
      type: String
    },
    canEdit: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      preloader: false,
      message: '',
      columns: [ 'order', 'date', 'user', 'status', 'total' ],
      options: {
        skin: 'table table-bordered table-hover',
        columnsClasses: {
          user: 'max-width'
        },
        filterByColumn: true,
        filterable: [ 'user' ],
        sortable: [],
        dateColumns: [ 'date' ],
        debounce: 1000,
        perPage: 30,
        pagination: {
          chunk: 30,
          dropdown: false
        },
        headings: {
          order: '#',
          date: 'Date',
          user: 'User',
          status: 'Status',
          total: 'Total'
        },
        childRowTogglerFirst: false,
      },
      itemsTable: {
        columns: [ 'name', 'price', 'qty', 'total', 'actions' ],
        options: {
          skin: 'table table-bordered table-hover',
          columnsClasses: {
            name: 'max-width'
          },
          filterByColumn: true,
          filterable: [],
          sortable: [],
          perPage: 99,
          pagination: {
            chunk: 99,
            dropdown: false,
            show: false
          },
          headings: {
            name: 'Name',
            price: 'Price',
            qty: 'Qty',
            total: 'Total',
          },
        },
      }
    }
  },
  computed: {
  },
  methods: {
    onLoading() {
      this.preloader = true;
    },
    onLoaded() {
      this.preloader = false;
    },
    getOrderTotal(order) {
      return order.items.reduce((a, v) => (a + v.price * v.qty), 0);
    },

    shipIt(order) {
      const self = this;
      return axios.post(`/api/shop/order/${order.id}`, { status: 'done' }).then(r => {
        if (r.data.error) {
          self.toast(r.data.error, 'error');
        } else {
          self.toast(r.data.success);
        }
      }).then(() => {
        this.$refs['orders-table'].getData();
      }).catch(e => {
        console.log(e);
        self.toast('Server error.', 'error');
      });
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    },
  }
}
</script>
